import { useState } from "react";
import { fetchIvfHistory } from "../../utils/patients/fetchIvfHistory";
import useProfileStore from "../../store/patient/profileStore";




const useManageIvfHistory = () => {
    const [loading, setLoading] = useState(false);
    const [ivf, setIvf] = useState([]);
    const {profile} = useProfileStore()


  const handleFetchIvfHistory = async () => {
    setLoading(true);
    try{
      const response = await fetchIvfHistory(profile?.id)
      
      setIvf(response.data);
      console.log(response.data);
      
    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      console.log("error error");
      localStorage?.setItem("user", null)

    } finally {
      setLoading(false)
    }
  };


  return {
    handleFetchIvfHistory,
    loading,
    ivf
  };

}

export default useManageIvfHistory;